import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  post: ['/api/shipment/interceptUnblock',],
})